import React from 'react'
import './Header.css'

import { Link } from 'react-router-dom'
import { translate } from 'react-i18next'

import '../assets/img/beckgraundHeder.jpg'
import { LogoSvg, TelSvg, MailSvg } from './SVGarr'
import Nav from './Nav'
import ButtonOrder from './ButtonOrder'

class Header extends React.Component {
  render() {
    const { t, i18n } = this.props
 
    const changeLanguage = (lng) => {
      i18n.changeLanguage(lng);
    }
    return(
      <React.Fragment>
        <header>
          <div className="hederTop">
            <Link to='/' className="aLogo"> {LogoSvg} </Link>
            <div className="tagline"> {t('headerH1')} </div>
            <div className="lang">
              <Link to='#' className="ua" onClick={() => changeLanguage('ua')} >UA</Link>
              <Link to='#' className="ru" onClick={() => changeLanguage('ru')} >RU</Link>
            </div>
          </div>
          <div className="headerBottom">
            <Nav />
            <div className="headerTel">
              <a href='tel:+380974690628'> {TelSvg} +38 097 469 06 28 </a>
              <a href='tel:+380663138105'> {TelSvg} +38 066 313 81 05 <div>Telegram Viber</div> </a>
              <a href='mailto:vazonstudia@gmail.com'> {MailSvg} vazonstudia@gmail.com </a>
            </div>
          </div>
          <div className="buttons">
            <Link to="/portfolio" className="bp"> {t('but1')} </Link>
            <ButtonOrder />
          </div>
        </header>
        <h1 className="headerDown"> {t('headerH2')} </h1>
      </React.Fragment>
    )
  }
}

export default translate('translations')(Header)


// WEBPACK FOOTER //
// ./src/components/Header.jsx